import React, { useState } from 'react';
import { Award, BookOpen, Upload, Bell } from 'lucide-react';
import './CreateCertification.css';

const CreateCertification: React.FC = () => {
  const [autoNotifications, setAutoNotifications] = useState(true);
  const [renewalReminders, setRenewalReminders] = useState(true);

  const courses = [
    'Advanced Leadership',
    'Team Management',
    'Strategic Planning',
    'Python for Data Science',
  ];

  const assessments = [
    'Leadership Assessment',
    'Data Science Final Exam',
    'Compliance Test',
    'PMP Practice Exam',
  ];

  return (
    <div className="admin-certifi-create-certification">
      <div className="admin-certifi-create-layout">
        <div className="admin-certifi-create-main">
          <div className="admin-certifi-form-section">
            <div className="admin-certifi-section-header">
              <Award size={20} />
              <h3>Certification Information</h3>
            </div>

            <div className="admin-certifi-form-field">
              <label htmlFor="cert-name">
                Certification Name <span className="admin-certifi-required">*</span>
              </label>
              <input
                type="text"
                id="cert-name"
                placeholder="e.g., Leadership Excellence Certificate"
              />
            </div>

            <div className="admin-certifi-form-field">
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                rows={3}
                placeholder="Describe the certification and its value..."
              />
            </div>

            <div className="admin-certifi-form-row">
              <div className="admin-certifi-form-field">
                <label htmlFor="validity">Validity Period</label>
                <select id="validity">
                  <option value="">Select Duration</option>
                  <option value="6">6 months</option>
                  <option value="12">12 months</option>
                  <option value="24">24 months</option>
                  <option value="36">36 months</option>
                </select>
              </div>

              <div className="admin-certifi-form-field">
                <label htmlFor="template">Badge/Certificate Template</label>
                <button className="admin-certifi-upload-btn">
                  <Upload size={16} />
                  Upload Template
                </button>
              </div>
            </div>
          </div>

          <div className="admin-certifi-form-section">
            <div className="admin-certifi-section-header">
              <BookOpen size={20} />
              <h3>Required Learning Items</h3>
            </div>

            <div className="admin-certifi-form-field">
              <label>Required Courses</label>
              <div className="admin-certifi-checkbox-list">
                {courses.map((course, index) => (
                  <label key={index} className="admin-certifi-checkbox-item">
                    <input type="checkbox" />
                    <span>{course}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="admin-certifi-form-field">
              <label>Required Assessments</label>
              <div className="admin-certifi-checkbox-list">
                {assessments.map((assessment, index) => (
                  <label key={index} className="admin-certifi-checkbox-item">
                    <input type="checkbox" />
                    <span>{assessment}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="admin-certifi-form-section">
            <div className="admin-certifi-section-header">
              <Bell size={20} />
              <h3>Notification Settings</h3>
            </div>

            <div className="admin-certifi-form-field">
              <div className="admin-certifi-toggle-field">
                <div>
                  <label>Auto-notifications</label>
                  <p className="admin-certifi-field-description">Send notifications upon certification</p>
                </div>
                <div
                  className={`admin-certifi-toggle-switch ${autoNotifications ? 'admin-certifi-toggle-active' : ''}`}
                  onClick={() => setAutoNotifications(!autoNotifications)}
                >
                  <div className="admin-certifi-toggle-thumb" />
                </div>
              </div>
            </div>

            <div className="admin-certifi-form-field">
              <div className="admin-certifi-toggle-field">
                <div>
                  <label>Renewal Reminders</label>
                  <p className="admin-certifi-field-description">Alert learners before expiry</p>
                </div>
                <div
                  className={`admin-certifi-toggle-switch ${renewalReminders ? 'admin-certifi-toggle-active' : ''}`}
                  onClick={() => setRenewalReminders(!renewalReminders)}
                >
                  <div className="admin-certifi-toggle-thumb" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="admin-certifi-create-sidebar">
          <div className="admin-certifi-sidebar-section">
            <h4>Actions</h4>
            <button className="admin-certifi-action-button admin-certifi-action-button-primary">
              <span className="admin-certifi-button-icon">✓</span>
              Publish
            </button>
            <button className="admin-certifi-action-button admin-certifi-action-button-secondary">
              <span className="admin-certifi-button-icon">📋</span>
              Save Draft
            </button>
            <button className="admin-certifi-action-button admin-certifi-action-button-secondary">
              <span className="admin-certifi-button-icon">✕</span>
              Cancel
            </button>
          </div>

          <div className="admin-certifi-sidebar-section admin-certifi-tips-section">
            <h4>
              <span className="admin-certifi-tips-icon">💡</span>
              Certification Tips
            </h4>
            <ul className="admin-certifi-tips-list">
              <li>Set realistic validity periods</li>
              <li>Include assessments for validation</li>
              <li>Enable renewal reminders</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCertification;
